import React from "react";
import { useSelector } from "react-redux";
import { APP_URL } from "../../shared/constants";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./EmailOrder.css";
import badgeImg from "../../assets/images/badge.jpeg";
import { useLocation } from "react-router-dom";
import { downloadInvoice } from "../Orders Details/InvoiceDownload/DownloadInvoice";

const EmailOrderPage = () => {
  const location = useLocation();
  const [userEmail, orderCode] = location.search?.replace("?", "")?.split(",");

  
  const settingsData = useSelector(
    (state) => state?.settingData?.settingDatas
  );

  const gstNumber = settingsData?.find(
    (item) => item?.key_name === "GST_NO"
  )?.key_value;
  const logo = settingsData?.find(
    (item) => item.key_name === "SITE_LOGO"
  )?.key_value;
  const address = settingsData?.find(
    (item) => item.key_name === "ADDRESS_ONE"
  )?.key_value;
  
  const email = settingsData?.find(
    (item) => item.key_name === "EMAIL_ONE"
  )?.key_value;
  const emailTwo = settingsData?.find(
    (item) => item.key_name === "EMAIL_TWO"
  )?.key_value;
  const phone = settingsData?.find(
    (item) => item.key_name === "PHONE_ONE"
  )?.key_value;
  const phoneTwo = settingsData?.find(
    (item) => item.key_name === "PHONE_TWO"
  )?.key_value;
  const gstNo = settingsData?.find(
    (item) => item.key_name === "GST_NO"
  )?.key_value;
  const placeofsupply = settingsData?.find(
    (item) => item.key_name === "PLACE_OF_SUPPLY"
  )?.key_value;
  const handleDownloadInvoice = () => {
    const appImage = logo && APP_URL + logo;

    downloadInvoice(
      null,
      appImage,
      address,
      phone,
      phoneTwo,
      email,
      emailTwo,
      "isUnAuth",
      orderCode,
      userEmail,
      gstNo,placeofsupply
    );
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
  <div className="text-center">
    <div>
      <img src={badgeImg} alt="Order Badge" width="150px" />
    </div>
    <h3 className="fw-bold">Thanks for your purchase!</h3>
    <p>
      We’ve received your order <span style={{ color: "var(--primary-color)" }}>{orderCode}</span> and it’s now being processed
    </p>
    <h5 className="download-text">Download your invoice here</h5>
    <button
      className="download-email-invoice px-4"
      onClick={() => handleDownloadInvoice()}
    >
      <FontAwesomeIcon icon={faFileExport} /> Order Invoice
    </button>
  </div>
</div>

  );
};

export default EmailOrderPage;
